import { seoContent } from '@/mocks/seo-content';

export default function ComparisonSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Intro text */}
        <div className="max-w-3xl mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 leading-tight">
            {seoContent.homepageIntro.heading}
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            {seoContent.homepageIntro.body}
          </p>
        </div>

        {/* Comparison Table */}
        <div>
          <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
            {seoContent.homepageComparison.heading}
          </h3>
          <div className="overflow-x-auto rounded-2xl border border-background-200/70">
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="bg-background-100">
                  <th className="px-5 py-4 text-foreground-500 font-medium text-xs uppercase tracking-wider whitespace-nowrap">
                    Factor
                  </th>
                  <th className="px-5 py-4 text-foreground-500 font-medium text-xs uppercase tracking-wider whitespace-nowrap">
                    Competitor Sites
                  </th>
                  <th className="px-5 py-4 text-foreground-900 font-semibold text-xs uppercase tracking-wider whitespace-nowrap bg-accent-100/50">
                    Pandabuyspreadsheet
                  </th>
                </tr>
              </thead>
              <tbody>
                {seoContent.homepageComparison.rows.map((row, i) => (
                  <tr key={i} className={`${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'} border-t border-background-200/40`}>
                    <td className="px-5 py-4 font-medium text-foreground-800 whitespace-nowrap">
                      {row.factor}
                    </td>
                    <td className="px-5 py-4 text-foreground-500 leading-relaxed">
                      {row.competitor}
                    </td>
                    <td className="px-5 py-4 text-foreground-900 font-medium leading-relaxed bg-accent-50/30">
                      {row.ourSite}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}